import { useRef, useState,useEffect } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import micro1 from '../../images/microphone_stop.png'
import micro2 from '../../images/microphone.png'
import './ConversationStyleSheet.css'



const TextToSpeech = props => {
  
  const { transcript,finalTranscript, resetTranscript } = useSpeechRecognition();
  const [isListening, setIsListening] = useState(false);
  const [text,setText] = useState("");
  // const [sent,isSent] = useState();
  const microphoneRef = useRef(null);

  const handleClick = () =>{
    let check = !isListening;
    resetTranscript();
    console.log("ckk",check)
    if(check)
    {
      setIsListening(true);
      console.log("listening",{transcript});
      microphoneRef.current.classList.add("listening");
      SpeechRecognition.startListening({
        continuous: true,
      });
    }else{
      stopHandle();
    }
  }
  
    
  const stopHandle = (data) => {
    setIsListening(false);
    

    microphoneRef.current.classList.remove("listening");
    SpeechRecognition.stopListening();
     resetTranscript();
    };

    useEffect(()=>{

      stopHandle();
    },[props.sent])


  useEffect(() => {
    console.log("t",props)
    if(isListening){
      console.log("text..",text) 
      console.log("sub",finalTranscript.substr(text.length))
      let val = text.length>0?finalTranscript.substr(text.length):finalTranscript;
      

      console.log("textValue",props.textValue+" "+val) 

     props.setTextValue(props.textValue+" "+val)  
    }
    let str = finalTranscript

     setText(str)

  },[finalTranscript]);
  

  return (
    <div className={localStorage.getItem("openInFullScreen") ?"microphone-wrapper-fs" : "microphone-wrapper"}>
      {<div className="mircophone-container">
        <div className="microphone-icon-container" ref={microphoneRef} onClick={handleClick}>
          {!isListening&& <img src={micro1} className="microphone-icon" />}
          {isListening&&<img src={micro2} style={{height:"20px",widht:"20px"}} className="microphone-icon" />}
        </div>      
      </div>}
    </div>
  );

};

export default TextToSpeech;